import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { changePasswordGuard } from './core/guards/change-password.guard';
import { permissionGuard } from './core/guards/permission.guard';
import { publicGuard } from './core/guards/public.guard';
import { PERMISSIONS } from './core/permissions/permission.constants';
 
export const routes: Routes = [
  { path: '', redirectTo: '', pathMatch: 'full' },
  {
    path: '',
    loadComponent: () => import('./pages/home-page/components/container/home-page.component').then(m => m.HomePageComponent),
    canActivate: [changePasswordGuard],
  },

  {
    path: 'profiles',
    canActivate: [authGuard, changePasswordGuard],
    loadChildren: () =>
      import('./pages/modules/user-profile/user-profile.routes').then(
        (m) => m.USER_PROFILE_ROUTES
      ),
  },
  {
    path: 'news',
    canActivate: [changePasswordGuard],
    loadChildren: () =>
      import('./pages/modules/news/news.routes').then((r) => r.NEWS_ROUTES),
  },
  {
    path: 'training',
    canActivate: [authGuard, permissionGuard],
    data: { permissions: [PERMISSIONS.SHOW_TRAINING_SECTION_MANAGEMENT] },
    loadChildren: () =>
      import('./pages/modules/training/training.routes').then(
        (r) => r.TRAINING_ROUTES
      ),
  },
  {
    path: 'services',
    canActivate: [authGuard, permissionGuard],
    data: { permissions: [PERMISSIONS.SHOW_SERVICES_SECTION] },
    loadChildren: () =>
      import('./pages/modules/apa-services/services.routes').then(
        (routes) => routes.servicesRoutes
      ),
  },
  {
    path: 'prosecution',
    canActivate: [changePasswordGuard],
    loadChildren: () =>
      import('./pages/modules/authority/authority.routes').then(
        (r) => r.AUTHORITY_ROUTES
      ),
  },
  {
    path: 'hiring',
    canActivate: [changePasswordGuard],
    loadChildren: () =>
      import('./pages/modules/hiring/hiring.routes').then(
        (r) => r.HIRING_ROUTES
      ),
  },
  {
    path: 'digitalLibrary',
    canActivate: [changePasswordGuard],
    loadChildren: () =>
      import('@cloud4rain_c4r/digital-library').then(
        (m) => m.CLIENT_DIGITAL_LIBRARY_ROUTES as any
      ),
  },
  {
    path: 'login',
    canActivate: [publicGuard],
    loadComponent: () => import('./pages/auth/components/view-befor-login/view-befor-login.component').then(m => m.ViewBeforLoginComponent),
  },
  {
    path: 'register',
    canActivate: [publicGuard],
    loadComponent: () => import('./pages/auth/components/register/register.component').then(m => m.RegisterComponent),
  },
  {
    path: 'auth/forgot-password',
    canActivate: [publicGuard],
    loadComponent: () => import('./pages/auth/components/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent),
  },
  {
    path: 'auth/reset-password',
    canActivate: [publicGuard],
    loadComponent: () => import('./pages/auth/components/reset-password/reset-password.component').then(m => m.ResetPasswordComponent),
  },
  {
    path: 'change-password',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/auth/components/change-password/change-password.component').then(m => m.ChangePasswordComponent),
  },
  {
    path: 'contactUs',
    canActivate: [changePasswordGuard],
    loadComponent: () => import('./pages/layout/contact-info/contact-info.component').then(m => m.ContactInfoComponent),
  },
  {
    path: 'privacy-policy',
    canActivate: [changePasswordGuard],
    loadComponent: () => import('./pages/layout/privacy-terms/privacy-policy-terms.component').then(m => m.PrivacyPolicyTermsComponent),
  },
  {
    path: 'delete-account-policy',
    canActivate: [changePasswordGuard],
    loadComponent: () => import('./pages/layout/privacy-terms/privacy-policy-terms.component').then(m => m.PrivacyPolicyTermsComponent),
    data: { showOnlyDelete: true }
  },
  { 
    path: '**', 
    loadComponent: () => import('./pages/ui-shared/page-not-found/page-not-found.component').then(m => m.PageNotFoundComponent),
    canActivate: [changePasswordGuard] 
  },
];
